import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DeficienciesIndex from './DeficienciesIndex.tsx';

export default function DeficienciesWrapper({ buildingOptions, buildingId }) {
  const queryClient = useMemo(() => new QueryClient(), []);

  return (
    <QueryClientProvider client={queryClient}>
      <DeficienciesIndex buildingOptions={buildingOptions} buildingId={buildingId} />
    </QueryClientProvider>
  );
}

DeficienciesWrapper.propTypes = {
  buildingOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      label: PropTypes.string,
      title: PropTypes.string
    })
  ),
  buildingId: PropTypes.number
};

DeficienciesWrapper.defaultProps = {
  buildingOptions: [],
  buildingId: undefined
};
